<template>
    <div class="simCardResource table-hook fadeInRight">
        <div class="title-box">
            <span class="m-title">号卡资源库</span>
            <el-form
                inline
                class="hook right themed-form search-form"
                v-model="form"
                style="line-height: 40px"
            >
                <el-form-item label="运营商:">
                    <el-input
                        v-model="form.account"
                        placeholder="请输入..."
                    ></el-input>
                </el-form-item>
                <el-form-item label="省份:">
                    <el-select v-model="form.province" placeholder="请选择...">
                        <el-option label="全部" value=""></el-option>
                        <el-option
                            v-for="(label, value) in provinceMap"
                            :key="value"
                            :label="label"
                            :value="label"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ICCID:">
                    <el-input
                        v-model="form.iccid"
                        placeholder="请输入..."
                    ></el-input>
                </el-form-item>
                <el-form-item label="接入号:">
                    <el-input
                        v-model="form.phone"
                        placeholder="请输入..."
                    ></el-input>
                </el-form-item>
                <el-form-item label="写卡状态:">
                    <el-select v-model="form.status" placeholder="请选择...">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="待写号" value="0"></el-option>
                        <el-option label="写号中" value="1"></el-option>
                        <el-option label="已写号" value="2"></el-option>
                        <el-option label="写号失败" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="isAdmin" label="代理商:">
                    <el-select
                        v-model="form.agentId"
                        filterable
                        clearable
                        placeholder="请选择代理商"
                    >
                        <el-option
                            v-for="item in agentThreeLists"
                            :key="item.agentId"
                            :label="item.agentName"
                            :value="item.agentId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="优先级:">
                    <el-select
                        v-model="form.priority"
                        clearable
                        placeholder="请选择优先级"
                    >
                        <el-option label="优先级1" value="1"></el-option>
                        <el-option label="优先级2" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡级密钥:">
                    <el-select
                        v-model="form.isCardKey"
                        clearable
                        placeholder="请选择"
                    >
                        <el-option label="全部" value=""></el-option>
                        <el-option label="否" value="0"></el-option>
                        <el-option label="是" value="1"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="开始时间:">
                    <el-date-picker
                        type="datetime"
                        placeholder="请选择日期时间"
                        v-model="form.startTime"
                        style="width: 100%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item label="结束时间:">
                    <el-date-picker
                        type="datetime"
                        placeholder="请选择日期时间"
                        v-model="form.endTime"
                        style="width: 100%"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        format="yyyy-MM-dd HH:mm:ss"
                    ></el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-search"
                        class="themed-button"
                        @click="searchData"
                        >查询</el-button
                    >
                </el-form-item>

                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-delete"
                        class="themed-button"
                        @click="batchDelete"
                        >批量删除</el-button
                    >
                </el-form-item>

                <el-form-item>
                    <el-button
                        type="primary"
                        icon="el-icon-back"
                        class="themed-button"
                        @click="exportExcel"
                        >导出</el-button
                    >
                </el-form-item>

                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-plus"
                        class="themed-button"
                        @click="importData"
                        >导入</el-button
                    >
                </el-form-item>

                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-edit"
                        class="themed-button"
                        @click="batchUpdateProvince"
                        >批量修改省份</el-button
                    >
                </el-form-item>
                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-safety-certificate"
                        class="themed-button"
                        @click="batchUpdateIsAuth"
                        >批量修改认证</el-button
                    >
                </el-form-item>
                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-key"
                        class="themed-button"
                        @click="batchUpdateIsCardKey"
                        >批量修改卡级密钥</el-button
                    >
                </el-form-item>
                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-s-custom"
                        class="themed-button"
                        @click="batchAssignAgent"
                        >批量分销代理商</el-button
                    >
                </el-form-item>
                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-shopping-card"
                        class="themed-button"
                        @click="batchRecycleCard"
                        >批量回收</el-button
                    >
                </el-form-item>
                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-sort"
                        class="themed-button"
                        @click="batchUpdatePriority"
                        >批量修改优先级</el-button
                    >
                </el-form-item>
                <el-form-item v-if="isAdmin">
                    <el-button
                        type="primary"
                        icon="el-icon-edit-outline"
                        class="themed-button"
                        @click="openBatchUpdateWriteStatus"
                        >批量修改写号状态</el-button
                    >
                </el-form-item>
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                ref="table"
                :data="tableData"
                stripe
                border
                :max-height="maxTableHeight"
            >
                <el-table-column
                    label="运营商"
                    prop="account"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="省份"
                    prop="province"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="ICCID"
                    prop="iccid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="接入号"
                    prop="phone"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="写卡状态"
                    prop="status"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ formatStatus(scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="代理商"
                    prop="agentName"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span
                            v-if="
                                scope.row.agentName &&
                                scope.row.agentName.trim() !== ''
                            "
                        >
                            {{ scope.row.agentName }}
                        </span>
                        <span v-else>
                            <el-tag type="info">未分销</el-tag>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="优先级"
                    prop="priority"
                    show-overflow-tooltip
                    width="100"
                    align="center"
                ></el-table-column>
                <el-table-column
                    label="是否认证"
                    prop="isAuth"
                    show-overflow-tooltip
                    width="100"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ formatAuth(scope.row.isAuth) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="卡级密钥"
                    prop="isCardKey"
                    show-overflow-tooltip
                    width="110"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ formatYesNo(scope.row.isCardKey) }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="关联EID"
                    prop="eid"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                    label="创建时间"
                    prop="createTime"
                    show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column v-if="isAdmin" label="操作" width="150px">
                    <template slot-scope="scope">
                        <el-button
                            type="primary"
                            size="mini"
                            class="themed-button"
                            @click="handleEdit(scope.row)"
                            >编辑</el-button
                        >
                        <el-button
                            type="danger"
                            size="mini"
                            class="themed-button"
                            @click="deleteById(scope.row)"
                            >删除</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[15, 30, 50, 100]"
                :page-size="pageSize"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>

        <!-- 编辑弹框 -->
        <el-dialog title="编辑" :visible.sync="editDialogVisible" width="500px">
            <el-form
                :model="editForm"
                :rules="editRules"
                ref="editFormRef"
                label-width="100px"
            >
                <el-form-item label="运营商:" prop="account">
                    <el-input
                        v-model="editForm.account"
                        placeholder="请输入运营商"
                    ></el-input>
                </el-form-item>
                <el-form-item label="省份:" prop="province">
                    <el-select
                        v-model="editForm.province"
                        placeholder="请选择省份"
                    >
                        <el-option
                            v-for="(label, value) in provinceMap"
                            :key="value"
                            :label="label"
                            :value="label"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ICCID:" prop="iccid">
                    <el-input
                        v-model="editForm.iccid"
                        placeholder="请输入ICCID"
                    ></el-input>
                </el-form-item>
                <el-form-item label="接入号:" prop="phone">
                    <el-input
                        v-model="editForm.phone"
                        placeholder="请输入接入号"
                    ></el-input>
                </el-form-item>
                <el-form-item label="关联EID:">
                    <el-input
                        v-model="editForm.eid"
                        placeholder="请输入EID"
                    ></el-input>
                </el-form-item>
                <el-form-item label="写号状态:" prop="status">
                    <el-select
                        v-model="editForm.status"
                        placeholder="请选择写号状态"
                        style="width: 100%"
                    >
                        <el-option label="待写号" :value="0"></el-option>
                        <el-option label="写号中" :value="1"></el-option>
                        <el-option label="已写号" :value="2"></el-option>
                        <el-option label="写号失败" :value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="优先级:">
                    <el-select
                        v-model="editForm.priority"
                        placeholder="请选择优先级"
                        style="width: 100%"
                    >
                        <el-option label="优先级1" value="1"></el-option>
                        <el-option label="优先级2" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否认证:">
                    <el-select
                        v-model="editForm.isAuth"
                        placeholder="请选择是否认证"
                        style="width: 100%"
                    >
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡级密钥:">
                    <el-select
                        v-model="editForm.isCardKey"
                        placeholder="请选择卡级密钥"
                        style="width: 100%"
                    >
                        <el-option label="否" :value="0"></el-option>
                        <el-option label="是" :value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    class="themed-button"
                    type="primary"
                    @click="submitEdit"
                    >确 定</el-button
                >
                <el-button
                    class="themed-button"
                    type="primary"
                    @click="cancelEdit"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 导入弹框 -->
        <el-dialog
            title="批量导入"
            :visible.sync="importDialogVisible"
            width="600px"
        >
            <el-form
                label-position="right"
                label-width="180px"
                style="max-height: 500px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:" required>
                    <input class="file-input" type="file" ref="importFile" />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="优先级:" required>
                    <el-select
                        v-model="importPriority"
                        placeholder="请选择优先级"
                        style="width: 100%"
                    >
                        <el-option label="优先级1" value="1"></el-option>
                        <el-option label="优先级2" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否认证:" required>
                    <el-select
                        v-model="importIsAuth"
                        placeholder="请选择是否认证"
                        style="width: 100%"
                    >
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡级密钥:" required>
                    <el-select
                        v-model="importIsCardKey"
                        placeholder="请选择卡级密钥"
                        style="width: 100%"
                    >
                        <el-option label="否" :value="0"></el-option>
                        <el-option label="是" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备卡信息:">
                    <el-input
                        v-model="importCardInfo"
                        type="textarea"
                        rows="6"
                        placeholder="请输入运营商 省份  ICCID 接入号，每行一组，用空格分开"
                    ></el-input>
                    <div style="color: #f00">
                        请输入运营商 省份 ICCID 接入号，每行一组，用空格分开
                    </div>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitImport"
                    >导入excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="importDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量删除弹框 -->
        <el-dialog
            title="批量删除"
            :visible.sync="deleteDialogVisible"
            width="500px"
        >
            <el-form
                label-position="right"
                label-width="200px"
                style="max-height: 500px"
            >
                <el-form-item label="上传文件（excel）:" required>
                    <input class="file-input" type="file" ref="deleteFile" />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="ICCID信息:">
                    <el-input
                        v-model="deleteIccidInfo"
                        type="textarea"
                        rows="6"
                        placeholder="请输入ICCID，每行一个"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchDelete"
                    >导入excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportDeleteTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="deleteDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量修改省份弹框 -->
        <el-dialog
            title="批量修改省份"
            :visible.sync="updateProvinceDialogVisible"
            width="500px"
        >
            <el-form
                label-position="right"
                label-width="200px"
                style="max-height: 500px"
            >
                <el-form-item label="上传文件（excel）:" required>
                    <input
                        class="file-input"
                        type="file"
                        ref="updateProvinceFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="省份:" required>
                    <el-select
                        v-model="updateProvinceForm.province"
                        placeholder="请选择省份"
                    >
                        <el-option
                            v-for="(label, value) in provinceMap"
                            :key="value"
                            :label="label"
                            :value="label"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ICCID信息:">
                    <el-input
                        v-model="updateProvinceForm.cardInfos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入ICCID"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchUpdateProvince"
                    >导入excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportUpdateProvinceTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="updateProvinceDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量修改认证弹框 -->
        <el-dialog
            title="批量修改认证"
            :visible.sync="updateIsAuthDialogVisible"
            width="500px"
        >
            <el-form
                label-position="right"
                label-width="200px"
                style="max-height: 500px"
            >
                <el-form-item label="上传文件（excel）:" required>
                    <input
                        class="file-input"
                        type="file"
                        ref="updateIsAuthFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="是否认证:" required>
                    <el-select
                        v-model="updateIsAuthForm.isAuth"
                        placeholder="请选择是否认证"
                        style="width: 100%"
                    >
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ICCID信息:">
                    <el-input
                        v-model="updateIsAuthForm.cardInfos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入ICCID"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchUpdateIsAuth"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportUpdateIsAuthTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="updateIsAuthDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量修改卡级密钥弹框 -->
        <el-dialog
            title="批量修改卡级密钥"
            :visible.sync="updateIsCardKeyDialogVisible"
            width="500px"
        >
            <el-form
                label-position="right"
                label-width="200px"
                style="max-height: 500px"
            >
                <el-form-item label="上传文件（excel）:" required>
                    <input
                        class="file-input"
                        type="file"
                        ref="updateIsCardKeyFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="卡级密钥:" required>
                    <el-select
                        v-model="updateIsCardKeyForm.isCardKey"
                        placeholder="请选择卡级密钥"
                        style="width: 100%"
                    >
                        <el-option label="否" :value="0"></el-option>
                        <el-option label="是" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="ICCID信息:">
                    <el-input
                        v-model="updateIsCardKeyForm.cardInfos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入ICCID"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchUpdateIsCardKey"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportUpdateIsCardKeyTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="updateIsCardKeyDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量分销弹框 -->
        <el-dialog
            title="批量分销代理商"
            :visible.sync="assignAgentDialogVisible"
            width="500px"
        >
            <el-form
                label-position="right"
                label-width="200px"
                style="max-height: 500px"
            >
                <el-form-item label="上传文件（excel）:">
                    <input
                        class="file-input"
                        type="file"
                        ref="assignAgentFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="代理商:" required>
                    <el-select
                        v-model="assignAgentForm.agentId"
                        filterable
                        clearable
                        placeholder="请选择代理商"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in agentThreeLists"
                            :key="item.agentId"
                            :label="item.agentName"
                            :value="item.agentId"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡号信息:">
                    <el-input
                        v-model="assignAgentForm.cardInfos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入卡号，每行一个（例如：898608341525 D0633008）"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchAssignAgent"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportAssignAgentTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="assignAgentDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量回收弹框 -->
        <el-dialog
            title="批量回收"
            :visible.sync="recycleCardDialogVisible"
            width="500px"
        >
            <el-form
                label-position="right"
                label-width="200px"
                style="max-height: 500px"
            >
                <el-form-item label="上传文件（excel）:" required>
                    <input
                        class="file-input"
                        type="file"
                        ref="recycleCardFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="卡号信息:" required>
                    <el-input
                        v-model="recycleCardForm.cardInfos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入卡号，每行一个（例如：898608341525 D0633008）"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchRecycleCard"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportRecycleCardTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="recycleCardDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量修改优先级弹框 -->
        <el-dialog
            title="批量修改优先级"
            :visible.sync="updatePriorityDialogVisible"
            width="500px"
        >
            <el-form
                label-position="right"
                label-width="200px"
                style="max-height: 500px"
            >
                <el-form-item label="上传文件（excel）:">
                    <input
                        class="file-input"
                        type="file"
                        ref="updatePriorityFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="优先级:" required>
                    <el-select
                        v-model="updatePriorityForm.priority"
                        placeholder="请选择优先级"
                        style="width: 100%"
                    >
                        <el-option label="优先级1" value="1"></el-option>
                        <el-option label="优先级2" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="卡号信息:">
                    <el-input
                        v-model="updatePriorityForm.cardInfos"
                        type="textarea"
                        rows="6"
                        placeholder="请输入卡号，每行一个（例如：898608341525 D0633008）"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchUpdatePriority"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportUpdatePriorityTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="updatePriorityDialogVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>

        <!-- 批量修改写号状态 -->
        <el-dialog
            title="批量修改写号状态"
            :visible.sync="batchUpdateWriteStatusVisible"
            width="560px"
        >
            <el-form
                label-position="right"
                label-width="140px"
                style="max-height: 520px; overflow: auto"
            >
                <el-form-item label="上传文件（excel）:">
                    <input
                        class="file-input"
                        type="file"
                        ref="batchUpdateWriteStatusFile"
                    />
                    <div class="mt5">
                        <span class="text-color" style="font-size: 12px"
                            >仅支持.xls/.xlsx格式</span
                        >
                    </div>
                </el-form-item>
                <el-form-item label="文本内容:">
                    <el-input
                        v-model="batchUpdateWriteStatusCardInfos"
                        type="textarea"
                        rows="8"
                        placeholder="ICCID 与写号状态成对输入，以空格分隔多条；示例：898608430525D0201844 1 898608631025D1060953 1。状态：0待写号、1写号中、2已写号、3写号失败"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="align-right">
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="submitBatchUpdateWriteStatus"
                    >确 定</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="exportBatchUpdateWriteStatusTemplate"
                    >导出excel模板</el-button
                >
                <el-button
                    type="primary"
                    class="themed-button"
                    @click="batchUpdateWriteStatusVisible = false"
                    >取 消</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    listSimCard,
    deleteById,
    exportSimCardSync,
    importExcel,
    batchDelete,
    editCard,
    batchUpdateProvince,
    batchUpdateIsAuth,
    batchUpdateIsCardKey,
    batchAssignAgent,
    batchRecycleSync,
    batchUpdatePriority,
    batchUpdateWriteStatus,
} from "@/api/writeCardManagement/simCardResource.js";
import { agentListForUser } from "@/api/cardManagement/cardBill.js";
import { messageBox, confirmBox } from "@/utils/common.js";
import resize from "@/mixins/resize.js";
import Utils from "@/utils/utils.js";
import { exportTemplate } from "@/api/statistics.js";
import { mapGetters } from "vuex";

export default {
    name: "simCardResource",
    mixins: [resize],
    computed: {
        ...mapGetters(["currentRole", "currentAgentId"]),
        // 是否是代理商账号登录
        isAgentAccount() {
            return this.currentRole != 0;
        },
        // 是否是管理员角色
        isAdmin() {
            return this.currentRole == 0;
        },
    },
    data() {
        return {
            form: {
                account: "",
                province: "",
                iccid: "",
                phone: "",
                status: "",
                eid: "",
                startTime: "",
                endTime: "",
                agentId: "",
                priority: "",
                isCardKey: "",
            },
            agentThreeLists: [],
            tableData: [],
            pageSize: 15,
            currentPage: 1,
            total: 0,
            maxTableHeight: 500,

            // 编辑弹框数据
            editDialogVisible: false,
            editForm: {
                id: "",
                account: "",
                province: "",
                iccid: "",
                phone: "",
                eid: "",
                status: 0,
                priority: "",
                isAuth: 1,
                isCardKey: 0,
            },
            editRules: {
                account: [
                    {
                        required: true,
                        message: "请输入运营商",
                        trigger: "blur",
                    },
                ],
                province: [
                    {
                        required: true,
                        message: "请选择省份",
                        trigger: "change",
                    },
                ],
                iccid: [
                    { required: true, message: "请输入ICCID", trigger: "blur" },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入接入号",
                        trigger: "blur",
                    },
                ],
                status: [
                    {
                        required: true,
                        message: "请选择写号状态",
                        trigger: "change",
                    },
                ],
            },

            // 省份映射数据
            provinceMap: {
                北京市: "北京市",
                天津市: "天津市",
                河北省: "河北省",
                山西省: "山西省",
                内蒙古自治区: "内蒙古自治区",
                辽宁省: "辽宁省",
                吉林省: "吉林省",
                黑龙江省: "黑龙江省",
                上海市: "上海市",
                江苏省: "江苏省",
                浙江省: "浙江省",
                安徽省: "安徽省",
                福建省: "福建省",
                江西省: "江西省",
                山东省: "山东省",
                河南省: "河南省",
                湖北省: "湖北省",
                湖南省: "湖南省",
                广东省: "广东省",
                广西壮族自治区: "广西壮族自治区",
                海南省: "海南省",
                重庆市: "重庆市",
                四川省: "四川省",
                贵州省: "贵州省",
                云南省: "云南省",
                西藏自治区: "西藏自治区",
                陕西省: "陕西省",
                甘肃省: "甘肃省",
                青海省: "青海省",
                宁夏回族自治区: "宁夏回族自治区",
                新疆维吾尔自治区: "新疆维吾尔自治区",
                台湾省: "台湾省",
                香港特别行政区: "香港特别行政区",
                澳门特别行政区: "澳门特别行政区",
                全国: "全国",
            },

            // 状态映射
            statusMap: {
                0: "待写号",
                1: "写号中",
                2: "已写号",
                3: "写号失败",
            },

            // 导入弹框数据
            importDialogVisible: false,
            importCardInfo: "",
            importPriority: "", // 导入优先级
            importIsAuth: 1, // 导入是否认证 1否 2是
            importIsCardKey: 0, // 导入卡级密钥 0否 1是

            // 批量删除弹框数据
            deleteDialogVisible: false,
            deleteIccidInfo: "",

            // 批量修改省份弹框数据
            updateProvinceDialogVisible: false,
            updateProvinceForm: {
                province: "",
                cardInfos: "",
            },

            // 批量修改认证弹框数据
            updateIsAuthDialogVisible: false,
            updateIsAuthForm: {
                isAuth: 1,
                cardInfos: "",
            },

            // 批量修改卡级密钥弹框数据
            updateIsCardKeyDialogVisible: false,
            updateIsCardKeyForm: {
                isCardKey: 0,
                cardInfos: "",
            },

            // 批量分销弹框数据
            assignAgentDialogVisible: false,
            assignAgentForm: {
                agentId: "",
                agentName: "",
                cardInfos: "",
            },

            // 批量回收弹框数据
            recycleCardDialogVisible: false,
            recycleCardForm: {
                cardInfos: "",
            },

            // 批量修改优先级弹框数据
            updatePriorityDialogVisible: false,
            updatePriorityForm: {
                priority: "",
                cardInfos: "",
            },

            // 批量修改写号状态
            batchUpdateWriteStatusVisible: false,
            batchUpdateWriteStatusCardInfos: "",
        };
    },
    mounted() {
        this.getAgentListForUser();
        this.getList();
    },
    activated() {
        this.getList();
    },
    methods: {
        // 获取代理商列表
        getAgentListForUser() {
            agentListForUser()
                .then((res) => {
                    this.agentThreeLists = res || [];
                })
                .catch((err) => {
                    console.error("获取代理商列表失败:", err);
                    this.agentThreeLists = [];
                });
        },
        // 获取列表数据
        getList() {
            console.log(typeof this.form.status);
            const params = {
                pageSize: this.pageSize,
                pageNo: this.currentPage,
                ...this.form,
            };

            // 如果是代理商账号登录，根据代理商ID过滤数据
            if (this.isAgentAccount && this.currentAgentId) {
                // 如果后端接口支持通过代理商ID查询，可以添加此参数
                // params.agentId = this.currentAgentId;
                // 或者如果写号资源库数据中有accountId字段，可以通过账号ID查询
                // 具体根据后端接口调整
            }

            listSimCard(params).then((res) => {
                if (res && res.page) {
                    this.tableData = res.page.rows || [];
                    this.total = res.page.total || 0;
                }
            });
        },

        // 搜索
        searchData() {
            this.currentPage = 1;
            this.getList();
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },

        // 导出
        exportExcel() {
            // 导出参数包含代理商(agentId)和优先级(priority)字段
            const params = Object.assign({}, this.form);
            exportSimCardSync(params).then((res) => {
                if (res.system_result_key == "0") {
                    this.$alert("导出成功，请到导出记录中下载", "提示", {
                        confirmButtonText: "确定",
                    }).then(() => {
                        this.$router.push("/tob/i_export_list");
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 删除单条
        deleteById(row) {
            confirmBox(
                this,
                `确定要删除ICCID为 ${row.iccid} 的记录吗？`,
                "操作提示",
                () => {
                    deleteById({ id: row.id }).then((res) => {
                        messageBox(this, "删除成功");
                        this.getList();
                    });
                }
            );
        },

        // 编辑操作
        handleEdit(row) {
            const st = row.status;
            const statusVal =
                st !== undefined && st !== null && st !== ""
                    ? Number(st)
                    : 0;
            this.editForm = {
                id: row.id,
                account: row.account,
                province: row.province,
                iccid: row.iccid,
                phone: row.phone,
                eid: row.eid,
                status: [0, 1, 2, 3].includes(statusVal) ? statusVal : 0,
                priority: row.priority || "",
                isAuth:
                    row.isAuth !== undefined && row.isAuth !== null
                        ? row.isAuth
                        : 1,
                isCardKey:
                    row.isCardKey === 1 ||
                    row.isCardKey === "1" ||
                    row.isCardKey === true
                        ? 1
                        : 0,
            };
            this.editDialogVisible = true;
            if (this.$refs.editFormRef) {
                this.$refs.editFormRef.clearValidate();
            }
        },

        // 提交编辑
        submitEdit() {
            this.$refs.editFormRef.validate((valid) => {
                if (!valid) {
                    return;
                }

                editCard(this.editForm)
                    .then((res) => {
                        if (res.system_result_key === "0") {
                            this.$message.success(
                                res.system_result_message_key || "编辑成功"
                            );
                            this.editDialogVisible = false;
                            this.getList();
                        } else {
                            this.$message.error(
                                res.system_result_message_key || "编辑失败"
                            );
                        }
                    })
                    .catch((err) => {
                        this.$message.error("编辑失败，请稍后重试");
                        console.error(err);
                    });
            });
        },

        // 取消编辑
        cancelEdit() {
            this.editDialogVisible = false;
            this.$refs.editFormRef.resetFields();
        },

        // 导入操作
        importData() {
            this.importDialogVisible = true;
            // 重置导入表单数据
            this.importCardInfo = "";
            this.importPriority = "";
            this.importIsAuth = 1;
            this.importIsCardKey = 0;
            if (this.$refs["importFile"]) {
                this.$refs["importFile"].value = "";
            }
        },

        // 提交导入
        submitImport() {
            // 验证优先级是否选择
            if (!this.importPriority) {
                messageBox(this, "请选择优先级");
                return;
            }

            let file = this.$refs["importFile"].files[0];
            let formData = new FormData();

            // 处理卡信息
            if (!file && !this.importCardInfo.trim()) {
                messageBox(this, "请选择文件或输入号卡信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 无论是否有文件，都添加卡信息和优先级到表单
            formData.append("cardInfos", this.importCardInfo);
            formData.append("priority", this.importPriority);
            formData.append("isAuth", this.importIsAuth);
            formData.append("isCardKey", this.importIsCardKey);

            importExcel(formData).then((res) => {
                if (res.system_result_key == "0") {
                    if (file) {
                        this.$alert(
                            res.system_result_message_key ||
                                "导入成功，请到导入记录中下载",
                            "提示",
                            {
                                confirmButtonText: "确定",
                            }
                        ).then(() => {
                            this.$refs["importFile"].value = "";
                            this.importCardInfo = "";
                            this.importPriority = "";
                            this.importIsAuth = 1;
                            this.importIsCardKey = 0;
                            this.importDialogVisible = false;
                            this.$router.push("/tob/i_import_list");
                        });
                    } else {
                        this.$message.success(
                            res.system_result_message_key || "导入成功"
                        );
                        this.importCardInfo = "";
                        this.importPriority = "";
                        this.importIsAuth = 1;
                        this.importIsCardKey = 0;
                        this.importDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 导出模板
        exportTemplate() {
            exportTemplate({ name: "importSimResource.xls" }).then((res) => {
                const filename = "importSimResource.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 批量删除操作
        batchDelete() {
            this.deleteDialogVisible = true;
        },

        // 提交批量删除
        submitBatchDelete() {
            let file = this.$refs["deleteFile"].files[0];
            let formData = new FormData();

            // 处理ICCID信息
            if (!file && !this.deleteIccidInfo.trim()) {
                messageBox(this, "请选择文件或输入ICCID信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 无论是否有文件，都添加ICCID信息到表单
            formData.append("iccids", this.deleteIccidInfo);

            batchDelete(formData).then((res) => {
                if (res.system_result_key == "0") {
                    this.$alert(
                        res.system_result_message_key || "删除成功",
                        "提示",
                        {
                            confirmButtonText: "确定",
                        }
                    ).then(() => {
                        if (file) this.$refs["deleteFile"].value = "";
                        this.deleteIccidInfo = "";
                        this.deleteDialogVisible = false;
                        this.getList();
                    });
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 导出删除模板
        exportDeleteTemplate() {
            exportTemplate({ name: "importIccid.xls" }).then((res) => {
                const filename = "importIccid.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 批量修改省份操作
        batchUpdateProvince() {
            this.updateProvinceDialogVisible = true;
            this.updateProvinceForm = {
                province: "",
                cardInfos: "",
            };
        },

        // 提交批量修改省份
        submitBatchUpdateProvince() {
            let file = this.$refs["updateProvinceFile"].files[0];
            let formData = new FormData();

            // 检查省份是否选择
            if (!this.updateProvinceForm.province) {
                messageBox(this, "请选择省份");
                return;
            }

            // 处理ICCID信息
            if (!file && !this.updateProvinceForm.cardInfos.trim()) {
                messageBox(this, "请选择文件或输入ICCID信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 添加省份和ICCID信息到表单
            formData.append("province", this.updateProvinceForm.province);
            formData.append("cardInfos", this.updateProvinceForm.cardInfos);

            batchUpdateProvince(formData).then((res) => {
                if (res.system_result_key == "0") {
                    if (file) {
                        this.$alert(
                            res.system_result_message_key ||
                                "修改成功，请到导入记录中下载",
                            "提示",
                            {
                                confirmButtonText: "确定",
                            }
                        ).then(() => {
                            this.$refs["updateProvinceFile"].value = "";
                            this.updateProvinceForm.cardInfos = "";
                            this.updateProvinceDialogVisible = false;
                            this.$router.push("/tob/i_import_list");
                        });
                    } else {
                        this.$message.success(
                            res.system_result_message_key || "修改成功"
                        );
                        this.updateProvinceForm.cardInfos = "";
                        this.updateProvinceDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 导出批量修改省份模板
        exportUpdateProvinceTemplate() {
            exportTemplate({ name: "importIccid.xls" }).then((res) => {
                const filename = "importIccid.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 批量修改认证操作
        batchUpdateIsAuth() {
            this.updateIsAuthDialogVisible = true;
            this.updateIsAuthForm = {
                isAuth: 1,
                cardInfos: "",
            };
        },

        // 提交批量修改认证
        submitBatchUpdateIsAuth() {
            let file = this.$refs["updateIsAuthFile"].files[0];
            let formData = new FormData();

            // 检查是否认证是否选择
            if (
                this.updateIsAuthForm.isAuth === undefined ||
                this.updateIsAuthForm.isAuth === null ||
                this.updateIsAuthForm.isAuth === ""
            ) {
                messageBox(this, "请选择是否认证");
                return;
            }

            // 处理ICCID信息
            if (!file && !this.updateIsAuthForm.cardInfos.trim()) {
                messageBox(this, "请选择文件或输入ICCID信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 添加是否认证和ICCID信息到表单
            formData.append("isAuth", this.updateIsAuthForm.isAuth);
            formData.append("cardInfos", this.updateIsAuthForm.cardInfos);

            batchUpdateIsAuth(formData).then((res) => {
                if (res.system_result_key == "0") {
                    if (file) {
                        this.$alert(
                            res.system_result_message_key ||
                                "修改成功，请到导入记录中下载",
                            "提示",
                            {
                                confirmButtonText: "确定",
                            }
                        ).then(() => {
                            this.$refs["updateIsAuthFile"].value = "";
                            this.updateIsAuthForm.cardInfos = "";
                            this.updateIsAuthDialogVisible = false;
                            this.$router.push("/tob/i_import_list");
                        });
                    } else {
                        this.$message.success(
                            res.system_result_message_key || "修改成功"
                        );
                        this.updateIsAuthForm.cardInfos = "";
                        this.updateIsAuthDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 导出批量修改认证模板
        exportUpdateIsAuthTemplate() {
            exportTemplate({ name: "importIccid.xls" }).then((res) => {
                const filename = "importIccid.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 批量修改卡级密钥操作
        batchUpdateIsCardKey() {
            this.updateIsCardKeyDialogVisible = true;
            this.updateIsCardKeyForm = {
                isCardKey: 0,
                cardInfos: "",
            };
            if (this.$refs["updateIsCardKeyFile"]) {
                this.$refs["updateIsCardKeyFile"].value = "";
            }
        },

        // 提交批量修改卡级密钥
        submitBatchUpdateIsCardKey() {
            let file = this.$refs["updateIsCardKeyFile"].files[0];
            let formData = new FormData();

            if (
                this.updateIsCardKeyForm.isCardKey === undefined ||
                this.updateIsCardKeyForm.isCardKey === null ||
                this.updateIsCardKeyForm.isCardKey === ""
            ) {
                messageBox(this, "请选择卡级密钥");
                return;
            }

            if (!file && !this.updateIsCardKeyForm.cardInfos.trim()) {
                messageBox(this, "请选择文件或输入ICCID信息");
                return;
            }

            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            formData.append("isCardKey", this.updateIsCardKeyForm.isCardKey);
            formData.append("cardInfos", this.updateIsCardKeyForm.cardInfos);

            batchUpdateIsCardKey(formData).then((res) => {
                if (res.system_result_key == "0") {
                    if (file) {
                        this.$alert(
                            res.system_result_message_key ||
                                "修改成功，请到导入记录中下载",
                            "提示",
                            {
                                confirmButtonText: "确定",
                            }
                        ).then(() => {
                            this.$refs["updateIsCardKeyFile"].value = "";
                            this.updateIsCardKeyForm.cardInfos = "";
                            this.updateIsCardKeyDialogVisible = false;
                            this.$router.push("/tob/i_import_list");
                        });
                    } else {
                        this.$message.success(
                            res.system_result_message_key || "修改成功"
                        );
                        this.updateIsCardKeyForm.cardInfos = "";
                        this.updateIsCardKeyDialogVisible = false;
                        this.getList();
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.system_result_message_key,
                        type: "error",
                    });
                }
            });
        },

        // 导出批量修改卡级密钥模板
        exportUpdateIsCardKeyTemplate() {
            exportTemplate({ name: "importIccid.xls" }).then((res) => {
                const filename = "importIccid.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 导出批量分销代理商模板
        exportAssignAgentTemplate() {
            exportTemplate({ name: "importIccid.xls" }).then((res) => {
                const filename = "importIccid.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 格式化状态
        formatStatus(status) {
            return this.statusMap[status] || "未知状态";
        },

        // 是否认证：1否 2是
        formatAuth(isAuth) {
            if (isAuth === 2 || isAuth === "2") return "是";
            if (isAuth === 1 || isAuth === "1") return "否";
            return isAuth != null && isAuth !== "" ? String(isAuth) : "-";
        },
        formatYesNo(val) {
            if (val === 1 || val === "1" || val === true) {
                return "是";
            }
            if (val === 0 || val === "0" || val === false) {
                return "否";
            }
            return "-";
        },

        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return "-";

            try {
                // 处理ISO格式的时间字符串
                const date = new Date(dateTime);
                if (isNaN(date.getTime())) return dateTime;

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                const hours = String(date.getHours()).padStart(2, "0");
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            } catch (error) {
                console.error("日期格式化错误:", error);
                return dateTime;
            }
        },

        // 批量分销操作
        batchAssignAgent() {
            this.assignAgentDialogVisible = true;
            this.assignAgentForm = {
                agentId: "",
                agentName: "",
                cardInfos: "",
            };
            // 清空文件选择
            if (this.$refs["assignAgentFile"]) {
                this.$refs["assignAgentFile"].value = "";
            }
        },

        // 提交批量分销
        submitBatchAssignAgent() {
            let file = this.$refs["assignAgentFile"].files[0];
            let formData = new FormData();

            // 检查代理商是否选择
            if (!this.assignAgentForm.agentId) {
                messageBox(this, "请选择代理商");
                return;
            }

            // 根据agentId找到对应的agentName
            let selectedAgent = this.agentThreeLists.find(
                (item) => item.agentId === this.assignAgentForm.agentId
            );
            if (!selectedAgent) {
                messageBox(this, "代理商信息不存在");
                return;
            }

            // 处理卡号信息：如果没有文件，必须有卡号信息
            if (!file && !this.assignAgentForm.cardInfos.trim()) {
                messageBox(this, "请选择文件或输入卡号信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 添加代理商ID、代理商名称和卡号信息到表单
            formData.append("agentId", this.assignAgentForm.agentId);
            formData.append("agentName", selectedAgent.agentName);
            formData.append("cardInfos", this.assignAgentForm.cardInfos);

            batchAssignAgent(formData)
                .then((res) => {
                    if (res.system_result_key == "0") {
                        this.$message.success(
                            res.system_result_message_key || "批量分销成功"
                        );
                        // 清空表单
                        this.assignAgentForm = {
                            agentId: "",
                            agentName: "",
                            cardInfos: "",
                        };
                        if (this.$refs["assignAgentFile"]) {
                            this.$refs["assignAgentFile"].value = "";
                        }
                        this.assignAgentDialogVisible = false;
                        // 刷新列表
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key,
                            type: "error",
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: "批量分销失败",
                        type: "error",
                    });
                });
        },

        // 批量回收操作
        batchRecycleCard() {
            this.recycleCardDialogVisible = true;
            this.recycleCardForm = {
                cardInfos: "",
            };
            // 清空文件选择
            if (this.$refs["recycleCardFile"]) {
                this.$refs["recycleCardFile"].value = "";
            }
        },

        // 提交批量回收
        submitBatchRecycleCard() {
            let file = this.$refs["recycleCardFile"].files[0];
            let formData = new FormData();

            // 处理卡号信息：文件或卡号信息至少需要一个
            if (!file && !this.recycleCardForm.cardInfos.trim()) {
                messageBox(this, "请选择文件或输入卡号信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 添加卡号信息到表单
            formData.append("cardInfos", this.recycleCardForm.cardInfos);

            batchRecycleSync(formData)
                .then((res) => {
                    if (res.system_result_key == "0") {
                        this.$message.success(
                            res.system_result_message_key || "批量回收成功"
                        );
                        // 清空表单
                        this.recycleCardForm = {
                            cardInfos: "",
                        };
                        if (this.$refs["recycleCardFile"]) {
                            this.$refs["recycleCardFile"].value = "";
                        }
                        this.recycleCardDialogVisible = false;
                        // 刷新列表
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key,
                            type: "error",
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: "批量回收失败",
                        type: "error",
                    });
                });
        },

        // 导出批量回收模板
        exportRecycleCardTemplate() {
            exportTemplate({ name: "importIccid.xls" }).then((res) => {
                const filename = "importIccid.xls";
                Utils.createDownload(res, filename);
            });
        },

        // 批量修改优先级操作
        batchUpdatePriority() {
            this.updatePriorityDialogVisible = true;
            this.updatePriorityForm = {
                priority: "",
                cardInfos: "",
            };
            // 清空文件选择
            if (this.$refs["updatePriorityFile"]) {
                this.$refs["updatePriorityFile"].value = "";
            }
        },

        // 提交批量修改优先级
        submitBatchUpdatePriority() {
            let file = this.$refs["updatePriorityFile"].files[0];
            let formData = new FormData();

            // 检查优先级是否选择
            if (!this.updatePriorityForm.priority) {
                messageBox(this, "请选择优先级");
                return;
            }

            // 处理卡号信息：如果没有文件，必须有卡号信息
            if (!file && !this.updatePriorityForm.cardInfos.trim()) {
                messageBox(this, "请选择文件或输入卡号信息");
                return;
            }

            // 如果有文件，检查文件格式并添加到表单
            if (file) {
                let fileName = file.name;
                let index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ==
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) == "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }

            // 添加优先级和卡号信息到表单
            formData.append("priority", this.updatePriorityForm.priority);
            formData.append("cardInfos", this.updatePriorityForm.cardInfos);

            batchUpdatePriority(formData)
                .then((res) => {
                    if (res.system_result_key == "0") {
                        this.$message.success(
                            res.system_result_message_key ||
                                "批量修改优先级成功"
                        );
                        // 清空表单
                        this.updatePriorityForm = {
                            priority: "",
                            cardInfos: "",
                        };
                        if (this.$refs["updatePriorityFile"]) {
                            this.$refs["updatePriorityFile"].value = "";
                        }
                        this.updatePriorityDialogVisible = false;
                        // 刷新列表
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key,
                            type: "error",
                        });
                    }
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: "批量修改优先级失败",
                        type: "error",
                    });
                });
        },

        // 导出批量修改优先级模板（与修改省份使用同一模板）
        exportUpdatePriorityTemplate() {
            exportTemplate({ name: "importIccid.xls" }).then((res) => {
                const filename = "importIccid.xls";
                Utils.createDownload(res, filename);
            });
        },

        openBatchUpdateWriteStatus() {
            this.batchUpdateWriteStatusVisible = true;
            this.batchUpdateWriteStatusCardInfos = "";
            this.$nextTick(() => {
                if (this.$refs["batchUpdateWriteStatusFile"]) {
                    this.$refs["batchUpdateWriteStatusFile"].value = "";
                }
            });
        },

        submitBatchUpdateWriteStatus() {
            const file = this.$refs["batchUpdateWriteStatusFile"]
                ? this.$refs["batchUpdateWriteStatusFile"].files[0]
                : null;
            const cardInfos = (this.batchUpdateWriteStatusCardInfos || "").trim();

            if (!file && !cardInfos) {
                messageBox(this, "请选择文件或填写文本内容");
                return;
            }

            const formData = new FormData();
            if (file) {
                const fileName = file.name;
                const index = fileName.lastIndexOf(".");
                if (
                    index < 0 ||
                    !(
                        fileName.substring(index + 1, fileName.length) ===
                            "xls" ||
                        fileName.substring(index + 1, fileName.length) === "xlsx"
                    )
                ) {
                    messageBox(this, "文件格式错误");
                    return;
                }
                formData.append("fileurl", file);
            }
            if (cardInfos) {
                formData.append("cardInfos", cardInfos);
            }

            batchUpdateWriteStatus(formData)
                .then((res) => {
                    if (res.system_result_key == "0") {
                        this.$message.success(
                            res.system_result_message_key ||
                                "批量修改写号状态成功"
                        );
                        this.batchUpdateWriteStatusCardInfos = "";
                        if (this.$refs["batchUpdateWriteStatusFile"]) {
                            this.$refs["batchUpdateWriteStatusFile"].value = "";
                        }
                        this.batchUpdateWriteStatusVisible = false;
                        this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.system_result_message_key,
                            type: "error",
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        showClose: true,
                        message: "批量修改写号状态失败",
                        type: "error",
                    });
                });
        },

        exportBatchUpdateWriteStatusTemplate() {
            const filename = "updateWriteStatusimport.xls";
            exportTemplate({ name: filename }).then((res) => {
                Utils.createDownload(res, filename);
            });
        },
    },
};
</script>

<style scoped>
.simCardResource {
    padding: 20px;
}

.content-box {
    margin-bottom: 20px;
}

.pagination {
    text-align: right;
    margin-top: 20px;
}

.file-input {
    display: inline-block;
}

.mt5 {
    margin-top: 5px;
}

.align-right {
    text-align: right;
    margin-top: 20px;
}

.text-color {
    color: #606266;
}

.info-box {
    padding: 10px;
    background-color: #f0f0f0;
    border-radius: 4px;
}
</style> 